import type { Component } from 'vue'
import { epPropKey, isObject } from './utils'
import { definePropType } from '@/components/watermark/element-utils'
import type {
    EpPropInput,
    IfEpProp,
    EpProp,
    IfNativePropType,
    EpPropConvert,
    NativePropType,
    EpPropMergeType,
    EpPropFinalized
} from './types'



export const isEpProp = (val: unknown): val is EpProp<any, any, any> =>
    isObject(val) && !!(val as any)[epPropKey]

export const iconPropType = definePropType<string | Component>([
    String,
    Object,
    Function,
])